__turbopack_context__.v({
  "className": "inter_c15e96cb-module__0bjUvq__className",
  "variable": "inter_c15e96cb-module__0bjUvq__variable",
});
